import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
const spin = "x1wc8ddo-B";
export const styles = {
  base: {
    k1xSpc: "x1rg5ohu",
    kXLuUW: "xxymvpz",
    kaIpWk: "x16rqkct",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kLZC3w: "x2sgaxv",
    kKVMdj: "x1aerksh",
    k44tkh: "xof6966",
    kyAemX: "x1esw782",
    ko0y90: "xa4qsjk",
    kmuXW: "x2lah0s",
    $$css: true
  },
  inherit: {
    kVAM5u: "x1r7ld26",
    kLZC3w: "x1v8p93f",
    kSiTet: "xiiclqw",
    $$css: true
  },
  block: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kzqmXN: "xh8yej3",
    kAzted: "x1db3i3o",
    $$css: true
  },
  sm: {
    kzqmXN: "x1kky2od",
    kZKoxP: "xlup9mm",
    kMzoRj: "xdh2fpr",
    $$css: true
  },
  md: {
    kzqmXN: "xvy4d1p",
    kZKoxP: "xxk0z11",
    kMzoRj: "xdh2fpr",
    $$css: true
  },
  lg: {
    kzqmXN: "x14qfxbe",
    kZKoxP: "xc9qbxq",
    kMzoRj: "x9r2w2z",
    $$css: true
  }
};